/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

(function () {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onDOMContentLoaded, {once: true})
  } else {
    onDOMContentLoaded()
  }

  function onDOMContentLoaded() {
    /* Hide if 0 reviews */
    if (window.location.href.indexOf("/products/") > -1) {
      if (document.querySelector('.product-meta__reference .rating__caption').textContent == 'No reviews') {
        document.querySelector('.product-meta__reference').style.display = 'none';
      }

      /* Convx 849: Atome waiter removed 2026-09-24. It watched for
         '.product-meta__price-list-container > .atome-widget', but the app renders that widget
         under '.product-meta', so the selector never matched, the promise never resolved and the
         MutationObserver below never disconnected: it observed every DOM change on every product
         page, for the life of the page, for nothing. The instalment line shoppers actually see is
         the theme's own, in snippets/product-info.liquid. */
    }

    QuickBuy();
    initStoreDetailsTab();
  }

  /* Allow the +x More button to open it's associated quick buy */
  function QuickBuy() {
    const view_more = document.querySelectorAll('.view-more button');
    for (const button of view_more) {
      button.addEventListener('click', function() {
          button.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('.product-item__quick-form button.hidden-tablet-and-up').click();
      })
    }
  }

  function initStoreDetailsTab() {
    const tabButtons = Array.from(document.querySelectorAll('.store-details-tab-section button[data-tab-id]'));

    for (const tabButton of tabButtons) {
      tabButton.addEventListener('click', switchTab.bind(null, tabButton, tabButtons));
    }
  }

  function switchTab(tabButton, tabButtons) {
    const tabId = tabButton.dataset.tabId;
    
    for (const x of tabButtons) {
      x.classList.remove('tab-active');
    }

    tabButton.classList.add('tab-active');

    const tabPanes = Array.from(document.querySelectorAll('.shopify-section--store-details .section'));

    for (const x of tabPanes) {
      if (x.dataset.tabId === tabId) {
        x.classList.add('tab-section-active');
      } else {
        x.classList.remove('tab-section-active');
      }
    }
  }
})();


/**
 * ------------------------------------------------------------------------------------------------------------
 * GWP CHECKOUT GUARD
 * ------------------------------------------------------------------------------------------------------------
 *
 * Added by Convx, 2026-09-17. Stops a customer checking out with an AutoCart gift they have not earned.
 *
 * Two parts:
 *   1. Greys out the checkout button while the cart is being re-evaluated, so the customer cannot outrun
 *      AutoCart's removal of the gift.
 *   2. Re-checks the cart at the moment of submit, and strips any gift whose spend threshold is not met
 *      before the form is allowed through. This part does not depend on AutoCart firing at all.
 *
 * To update for a new campaign, edit GWP_RULES only. Handles must match the product handle exactly.
 * Thresholds are in cents, so RM499 is 49900.
 *
 * KNOWN LIMITS: this is client side. It does not cover express checkout buttons (Shop Pay, PayPal), direct
 * navigation to /checkout, or a customer with devtools open. The server-side fix is the Buy X Get Y
 * discount rebuild. Do not treat this file as the enforcement layer.
 */
(function () {
  var GWP_RULES = {
    'gwp-shoe-laundry-bag-not-for-sale': 49900, // RM499
    'gwp-gym-bag-not-for-sale': 59900           // RM599
  };

  var GWP_HANDLE_PREFIX = 'gwp-';   // any unlisted gwp- product falls back to DEFAULT_MIN
  var DEFAULT_MIN = 49900;
  var FORMS = '#mini-cart-form, .cart__recap';
  var LOCK_TIMEOUT = 4000;          // fail open after this, never strand a paying customer
  var DEBUG = false;                // set true while testing to trace in the console

  var releaseTimer = null;

  function log() {
    if (!DEBUG) return;
    console.log.apply(console, ['[gwp-guard]'].concat(Array.prototype.slice.call(arguments)));
  }

  function buttons() {
    return document.querySelectorAll('button[name="checkout"]');
  }

  function lock() {
    Array.prototype.forEach.call(buttons(), function (b) {
      b.disabled = true;
      b.setAttribute('aria-disabled', 'true');
      b.style.opacity = '0.5';
      b.style.pointerEvents = 'none';
    });
    clearTimeout(releaseTimer);
    releaseTimer = setTimeout(function () {
      log('lock timed out, failing open');
      unlock();
    }, LOCK_TIMEOUT);
    log('locked');
  }

  function unlock() {
    clearTimeout(releaseTimer);
    Array.prototype.forEach.call(buttons(), function (b) {
      b.disabled = false;
      b.removeAttribute('aria-disabled');
      b.style.opacity = '';
      b.style.pointerEvents = '';
    });
    log('unlocked');
  }

  function isGift(handle) {
    return !!handle && handle.indexOf(GWP_HANDLE_PREFIX) === 0;
  }

  // Returns 1-indexed line numbers of gifts in the cart whose threshold is not met.
  function unearned(cart) {
    var qualifying = 0;
    cart.items.forEach(function (item) {
      if (!isGift(item.handle)) qualifying += item.final_line_price;
    });

    var strip = [];
    cart.items.forEach(function (item, idx) {
      if (!isGift(item.handle)) return;
      var min = GWP_RULES[item.handle] !== undefined ? GWP_RULES[item.handle] : DEFAULT_MIN;
      if (qualifying < min) strip.push(idx + 1);
    });

    log('qualifying spend', qualifying, 'strip lines', strip);
    return strip;
  }

  // Remove bottom up so earlier line numbers stay valid as we go.
  function removeLines(lines) {
    return lines
      .sort(function (a, b) { return b - a; })
      .reduce(function (chain, line) {
        return chain.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: line, quantity: 0 })
          });
        });
      }, Promise.resolve());
  }

  function cartHasGift(cart) {
    return !!cart && !!cart.items && cart.items.some(function (i) { return isGift(i.handle); });
  }

  // Part 1: lock the button while the cart is in flux, but ONLY when a gift is actually in the cart.
  // Focal passes the cart on the event detail. With no gift there is nothing to strip, so ordinary
  // shoppers never meet a disabled button even if AutoCart's own events are not switched on.
  // Also nudge AutoCart to re-evaluate immediately, so the lock stays short.
  var lastNudge = 0;
  document.addEventListener('cart:updated', function (event) {
    var cart = event.detail && event.detail.cart;
    if (cartHasGift(cart)) lock();

    var now = Date.now();
    if (now - lastNudge < 500) return; // AutoCart's own removal fires cart:updated, do not loop
    lastNudge = now;
    document.dispatchEvent(new Event('handle-autocart'));
  });

  document.addEventListener('autocart:before', lock);
  document.addEventListener('autocart:updated', unlock);
  document.addEventListener('autocart:error', unlock);

  // Part 2: final check at submit. form.submit() does not re-fire this listener, and Focal keeps a
  // hidden input[name="checkout"] in both forms, so the native submit still routes to checkout.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches(FORMS)) return;

    event.preventDefault();
    log('submit intercepted on', form.id || form.className);

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var strip = unearned(cart);
        if (!strip.length) {
          log('cart qualifies, proceeding to checkout');
          form.submit();
          return;
        }
        return removeLines(strip).then(function () {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          unlock();
          window.alert('Your free gift has been removed as your order no longer meets the minimum spend.');
        });
      })
      .catch(function (err) {
        log('check failed, failing open', err);
        form.submit();
      });
  }, true);

  log('loaded');
})();
